import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';

import { clientActions } from '../../_actions';
import FormComponent from './FormComponent';
import EnhancedTable from './EnhancedTable';
import './TableStyle.css';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap'
    },
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            clientData: null,
        };
    }

    componentDidMount() {
        this.props.dispatch(clientActions.getAll());
    }

    handleOpen = () => {
        this.setState({
            open: true,
            clientData: null,
        });
    };

    handleClose = () => {
        this.cleanData();
    };

    handleEditTable = (EditData) => {
        this.setState({
            clientData: EditData,
            open: true
        })
    }

    handleDeleteTable = (DeleteData) => {
        this.props.dispatch(clientActions.delete(DeleteData));
    }

    cleanData() {
        this.setState({
            open: false,
            clientData: null,
        });
    }

    render() {
        return (
            <div>
                <EnhancedTable
                    handleOpen={this.handleOpen}
                    handleEditTable={this.handleEditTable}
                    handleDeleteTable={this.handleDeleteTable}
                    departmentId={this.props.user.departmentId}
                />

                <FormComponent
                    open={this.state.open}
                    close={this.handleClose}
                    clientData={this.state.clientData}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { clients } = state;

    return {
        user,
        clients
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(App);


// WEBPACK FOOTER //
// ./src/components/Clients/App.js